var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-separator",class:[_vm.chatSeparatorClass, _vm.chatFixedClass],on:{"click":_vm.emitClick}},[_c('span',{staticClass:"u-txt--fair c-separator__text"},[_vm._v(_vm._s(_vm.separatorText))])])}
var staticRenderFns = []

export { render, staticRenderFns }